// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Person } from "../../data/app-core/person";
import { OrganizationalUnit } from "../../data/app-core/organizational-unit";
import { GroupDocument } from "./documents/group-document";
import { ItemEnvelope } from "./base/item-envelope";

export class GroupEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Group");
		if (jsonEnvelope) {
			this.PersonsPool = jsonEnvelope.PersonsPool;
			this.OrganizationalUnitPool = jsonEnvelope.OrganizationalUnitPool;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public PersonsPool: Person[] = [];
	public OrganizationalUnitPool: OrganizationalUnit[] = [];
	public override Document: GroupDocument = new GroupDocument();
	public override get ItemId(): number { return this.Document.Item.GroupId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}